var isIE = (function () {
	"use strict";

	var ret, isTheBrowser,
		actualVersion,
		jscriptMap, jscriptVersion;

	isTheBrowser = false;
	jscriptMap = {
		"5.5": "5.5",
		"5.6": "6",
		"5.7": "7",
		"5.8": "8",
		"9": "9",
		"10": "10"
	};
	jscriptVersion = new Function("/*@cc_on return @_jscript_version; @*/")();

	if (jscriptVersion !== undefined) {
		isTheBrowser = true;
		actualVersion = jscriptMap[jscriptVersion];
	}

	ret = {
		isTheBrowser: isTheBrowser,
		actualVersion: actualVersion
	};

	return ret;
}());

jQuery(function($){
	var $body = $('#body');
	var $main = $('#main');
	var $nav = $('#nav');
	var $itemMenuOut = $('#item-menu-out');
	var $header = $('.header');
	var $search = $header.find('.search');
	var $searchLink = $search.find('.search-link');
	var $searchInput = $search.find('.input');
	var $searchMob = $nav.find('.search');
	var $searchForm = $('#header-search');
	var $navOpen = $('#nav-open');
	var $navClose = $('#nav-close');
	var $linkGgid = $('#link-table');
	var $linkList = $('#link-list');
	var $list = $('#list');
	var $btnMore = $('#btn-more');
	var $navPage = $('#nav-page');
	var $navPageIn = $navPage.find('.nav-page-in');
	var $imgLinkJPG = $main.find('a[href$=".jpg"]');
	var $imgLinkPNG = $main.find('a[href$=".png"]');
	var $full = true;
	var bodyContent = $body.css('content');
	var $input = $('input');
	var $windowH = $(window).height();
	var $breakpoint = parseInt($('head').css('fontSize'));
	var searchOpened = false;
	var mobile = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));

	var bodyContentReplased = bodyContent;

	var $scrollStart = $(document).scrollTop();

	$('.swipebox').swipebox();

	$('.select-box').select2({
		minimumResultsForSearch: Infinity
	});

	// IE10 Header hack
	var $headerH;
	if (isIE.isTheBrowser)
		$headerH = 100;
	else
		$headerH = document.getElementById('header').offsetHeight;

	var $factBox = $('.fact-box');

	//pages
	var $front = $('.home');
	var $projectList = $('.projects-content');
	var $newsList = $('.news-list');
	var $contactList = $('.contact-list');
	var $searchPage = $('.search-page');
	var $projectsSingle = $('.projects-single');
	var $contactSingle = $('.contact-single');
	var $workWithUs = $('.work-with-us');
	var $projectsTimeline = $('.projects-timeline');

	var $searchBig = $searchPage.find('#menu-search .input');

	//ie11 detect
		navigator.sayswho= (function(){
		    var ua=  navigator.userAgent, tem,
		    M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*([\d\.]+)/i) || [];
		    if(/trident/i.test(M[1])){
		        tem=  /\brv[ :]+(\d+(\.\d+)?)/g.exec(ua) || [];
		        return 'IE '+(tem[1] || '');
		    }
		    M= M[2]? [M[1], M[2]]:[navigator.appName, navigator.appVersion, '-?'];
		    if((tem= ua.match(/version\/([\.\d]+)/i))!= null) M[2]= tem[1];
		    return M.join(' ');
		})();


		if(navigator.sayswho == 'IE 11.0') {
		    document.querySelector('body').className += ' ie11';
		}

	//ie10
		if (document.all && window.atob) {
		    $body.addClass('ie10');
		}

	//img no click
		$imgLinkJPG.click(function(event) {
			event.preventDefault();
		});
		$imgLinkPNG.click(function(event) {
			event.preventDefault();
		});

	//main padding-top
		$main.css('paddingTop',$headerH);

	// video-caption play
	$('.video-caption-container .play-btn').on('click', function () {
		var $mainContainer = $(this).parents('.video-caption-container'),
			iframe = $mainContainer.data('frame'),
			$videoContainer = $mainContainer.find('.video-container');

		$mainContainer.addClass('playing');
		$videoContainer.append(iframe);
	});

	//vacancy side-bar affix
	if (!mobile) {
		$("#sticky-sidebar").stick_in_parent({
			offset_top: 120
		});
	}

	//smooth scroll-to
	$(function() {
		$('a[href*="#"]:not([href="#"])').click(function() {
			if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				if (target.length) {
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1000);
					return false;
				}
			}
		});
	});

	//scroll
		function myScroll(){
			$('.scroll').on('click touchstart',function(e){
				$flag = false;
				//console.log($flag);
				e.preventDefault();
				var target = $(this).attr('href');
				$('html, body').animate({scrollTop: $(target).offset().top}, 1000);
				//console.log(target);
				// return false;
				// setInterval(function(){
				// 	$flag = true;
				// },1000);
			});
			//console.log($flag);
		};
		myScroll();

	//table - list
		var caseListItem = $('#case-nav').find('.link'); 

		caseListItem.on('click touchstart',function(event) {


			var targetId = event.target.id;

			if ($(this).parent().hasClass('current-menu-item')) {
				return false;
			};

			if (targetId == 'link-list') {
				$body.addClass('list-active');
				// if ($list.length && listItemNumber > 6) {
				// 	listShow();
				// };
			}
			else{
				$body.removeClass('list-active');
				// if ($list.length && listItemNumber > 6) {
				// 	listShow();
				// };
			};

			caseListItem.parent().removeClass('current-menu-item');
			$(this).parent().addClass('current-menu-item');
			//event

		});

	//flexslider

		$('#flexslider-front').flexslider({
			controlNav: false,
			directionNav: false
		});


		$('#flexslider-projects-single').flexslider({
			//controlNav: false
		});

		$('#flexslider-career').flexslider({
			//controlNav: false
		});

	//fancybox
		var fancyBoxThumbs = $('.fancybox-thumbs');
		if ( $breakpoint == 8888) {

			fancyBoxThumbs.fancybox({
				prevEffect : 'fade',
				nextEffect : 'fade',
				nextClick : true,
				padding: 0,
			});    	
			
		}
		else{
			fancyBoxThumbs.click(function(event) {
				event.preventDefault();
			});
		}


	//sticky header

	function stickyHeader () {

		var tempScrollTop, currentScrollTop = 0;

		$(window).scroll(function(){

			var myScrollTop = 0;
			myScrollTop = $(window).scrollTop();
			var scrollStart = 0;
			var docH = $(document).height();
			var windowH = $(window).height();

			//console.log(myScrollTop);

			if(myScrollTop == 0){
				$header.removeClass('header-sticky header-sticky-show')
			}
			else if ( myScrollTop > $headerH ) {
				$header.addClass('header-sticky')
			}
			else if($header.hasClass('header-sticky-show')){
				return false;
			}
			else{
				$header.removeClass('header-sticky');
			};

			if  (myScrollTop >= docH - windowH) 
				{
					return false;
				}
			else if (tempScrollTop > myScrollTop )
			{
				$header.addClass('header-sticky-show');
			}
			else if(myScrollTop > $headerH &&($header.hasClass('header-sticky-show'))){
				$header.removeClass('header-sticky-show');
			};

			if ( (myScrollTop > $headerH+30) ) {
				$header.addClass('header-transition');
			}
			else if(myScrollTop < 10){
				$header.removeClass('header-transition');
			};

			tempScrollTop = myScrollTop;

		});



		
	};

	function stickyHeaderMob(){

		$header.clone().removeAttr("id").prependTo($main);
		// $header.addClass('header-sticky header-transition')

		$header = $('.header');
		$navOpen = $header.find('.nav-icon-open .link');
		$search = $header.find('.search');
		$searchInput = $search.find('.input');


		var ystart = 0, ymove = 0;
		$('section').on('touchstart', function (e) {

			
			ystart = e.originalEvent.touches[0].clientY;
			ymove = e.originalEvent.touches[0].clientY;

			var myScrollTop = 0;
			myScrollTop = $(window).scrollTop();
			var scrollStart = 0;
			var docH = $(document).height();
			var windowH = $(window).height();

				})
				.on('touchmove', function (e) {
	
					ymove = e.originalEvent.touches[0].clientY;				

					if (ystart - ymove > 50) {
						$header.removeClass('header-sticky-show');    
						$searchInput.blur();
					}; 

					if (ymove - ystart > 30) {	
						$header.addClass('header-sticky-show'); 
						$searchInput.blur();
					};
				})



	};
		

	// if ($projectsSingle.length && (  $breakpoint == 8888  ) ) {
	// }	
	// else if(    $breakpoint == 8888     ){
	// 	stickyHeader(); 
	// }
	// else if(  (!($front.length))  && ($breakpoint == 1024) || ($breakpoint == 767)  ){
	// 	stickyHeaderMob();
	// };



	//nav open
		$navOpen.on('touchstart, click', function(event) {
			if($('.unit-mob-open').length){
				$('.unit-mob-open').removeClass('unit-mob-open')
				return false
			};
			$body.toggleClass('nav-open');
			if ($body.hasClass('nav-open') && ($breakpoint == 8888 )  ) {
				setTimeout(function(){
					$navPageIn.addClass('nav-page-in-no-transition');
				},400);

			};
			return false;
		});	
	//nav close	
		$navClose.on('touchstart, click', function(event) {
			$body.removeClass('nav-open');
			$navPageIn.removeClass('nav-page-in-no-transition');
			return false;
		});	

		$itemMenuOut.on('touchstart, click',function(event) {
			$body.removeClass('nav-open');
			$navPageIn.removeClass('nav-page-in-no-transition');
			return false;
		});	

	//close on main click
		$main.on('touchstart click', function(event) {
			$body.removeClass('nav-open');
			$navPageIn.removeClass('nav-page-in-no-transition');
			//$search.removeClass('search-open');
		});
	    
	//Searchform header
	    if($search.length > 0) {
		    $search.on('click', function(e) {
		        searchOpened = !searchOpened;
		        e.stopPropagation();
		        $body.toggleClass('search-form-open');
		        // Autofous
		        if(searchOpened) {
		        	setTimeout(function(){
						$('#header-search > #menu-search > .input').focus();
					}, 600);	
		        } else {
					$('#header-search > #menu-search > .input').blur();
		        }
			});
	    }
		// $body.on('touchstart click', function(e) {
		// 	if (searchOpened) {
	 //            searchOpened = !searchOpened;
	 //            $body.removeClass('search-form-open');
		//     }
		// });
	//Close on body (but not form click) click
		// $searchForm.on('touchstart click', function(e) {
	 //    	e.stopPropagation();
	 //    });


		// Original search
		// $search.find('form').on('touchstart click', function(event) {
		// 	if (!$(this).parents('.search').hasClass('search-open')) {
		// 		$(this).parents('.search').addClass('search-open');
		// 		if ( $('body').css('content')=='tab' ) {
		// 			$('body,html').animate({scrollTop: 0}, 500);			
		// 		};
		// 		$(this).find('.input').focus();
		// 		event.preventDefault();
				
		// 	};
		// 	/* Act on the event */
		// });

		// $search.find('.input').on('focusout', function(event) {
		// 	$search.removeClass('search-open');
		// });


	//search overlay
		var searchInputClose = $('#search-input-close');
		var searchOverlayInput = $('.search-overlay').find('.input');

		$searchMob.on('click touchstart',function(event) {
			$body.addClass('search-mob');
			//searchOverlayInput.focus();
			return false;
		});

		searchInputClose.on('click touchstart',function(event) {
			$body.removeClass('search-mob');
			searchOverlayInput.blur();
			return false;
		});	

//list
	function listShow	(list, numInRoll){

		var listItem = list.find('.item');
		var listItemNumber = listItem.length;
		//var listItemMargin = parseInt(listItem.css('marginBottom'));
		//var listItemH = listItem.find('.link').innerHeight();
		var numberRoll = list.data('count');
		var numItem = numberRoll*2;
		// if (($('.list-active').length)||$('body').css('content')=='mob') {
		// 	var numItem = numItem*2;
		// }


		if (!numInRoll) {
			numInRoll = 3;
		};
		if (!numberRoll) {
			numberRoll = 3;
		};

		listItem.each(function() {
			if ($(this).index()<numItem) {
				$(this).addClass('item-visible')
			};
		});

		if (numInRoll*numberRoll < listItemNumber) {

			if (($('.list-active').length)||$('body').css('content')=='mob') {
				var numberRoll = numberRoll*2;
			}
			
			//var listMaxH = ((listItemH+listItemMargin)*numberRoll);
			//list.css('maxHeight', listMaxH);

			$btnMore.addClass('btn-arrow-visible');

			$btnMore.on('click touchstart',function(event) {
				$body.addClass('list-open');
				$(this).removeClass('btn-arrow-visible');
				listItem.addClass('item-visible');
				event.preventDefault();
			});
			
		};

	};

	// listShow($contactList.find('#list'), 2);

	$( window ).on( "orientationchange resize", function() {
		// listShow($contactList.find('#list'), 2);
		if ($front.length) {
			setTimeout(function(){
				$('.text').trigger("update.dot");
				$('.title').trigger("update.dot");
			},100);
		};	
	});

	caseListItem.on('click touchstart',function(event) {
		listShow($contactList.find('#list'), 2);
	});

	//Contact page employee card click/hover
	// var employees = Array.prototype.slice.call(document.querySelectorAll('.contact-list li'));
	// employees.forEach(function(item) {
	// 	var links = Array.prototype.slice.call(item.querySelectorAll('a'));
	// 	links.forEach(function(link) {
	// 		link.onclick = function(e) {
	// 			e.stopPropagation();
	// 		}
	// 	})
	// 	item.onclick = function(e) {
	// 		var goto = e.target.getAttribute('data-href') || $(e.target).closest('.item').attr('data-href');
	// 		window.open(goto, "_blank");
	// 	}
	// 	item.addEventListener('mouseenter', function(e) {
	// 		if (checkHover(e)) item.classList.add('active-hover')
	// 	})
	// 	item.addEventListener('mousemove', function(e) {
	// 		if (checkHover(e) && !item.classList.contains('active-hover')) {
	// 			item.classList.add('active-hover')
	// 		} else if (!checkHover(e)) {
	// 			item.classList.remove('active-hover')
	// 		}
	// 	})
	// 	item.addEventListener('mouseleave', function(e) {
	// 		item.classList.remove('active-hover')
	// 	})
	// })
	// function checkHover(e) {
	// 	if (e.target.tagName.toUpperCase() === 'A' && !e.target.classList.contains('more')) {
	// 		return false;
	// 	}
	// 	return true;
	// }
	

//iframe video
	$('iframe').each(function(){
			var url = $(this).attr("src");
			$(this).attr("src",url+"?wmode=transparent");
	});	

//timeline

	function timelineList(){

		if ( $breakpoint == 8888) {

			var timelineList = $('#timeline777');
			var timelineItem = timelineList.find('.item');
			// var timelineItemLinePosition = 0;
			// var timelineItemLinePositionPrev = 0
			// var halfScreen = ($(window).outerWidth())/2;

				timelineItem.eq(0).addClass('timeline-left');
						timelineItem.eq(1).addClass('timeline-right');
						for(var i=2;i<timelineItem.length;i++){


								var listLeft = timelineList.find('.timeline-left');
								var listLeftHeight=0;


								for(var j=0;j<listLeft.length;j++){
										listLeftHeight+=listLeft.eq(j).outerHeight();
								}


								var listRight = timelineList.find('.timeline-right');
								var listRightHeight=0;
								for(var k=0;k<listRight.length;k++){
										listRightHeight+=listRight.eq(k).outerHeight();
								}


								if(listLeftHeight<=listRightHeight){
										timelineItem.eq(i).addClass('timeline-left');
								}
								else{
										timelineItem.eq(i).addClass('timeline-right');
								}


						}


			// //add right-left
			// 	timelineItem.filter(':odd').addClass('timeline-right');
			// 	timelineItem.filter(':even').addClass('timeline-left');

			// //correct right-left
			// 	timelineItem.each(function() {
			// 		var activeItem = $(this);
			// 		var itemPositionIndex = activeItem.offset().left + 10;
			// 		if ( activeItem.hasClass('timeline-left') && (itemPositionIndex > halfScreen) ) {
			// 			activeItem.removeClass('timeline-left').addClass('timeline-right');
			// 		}
			// 		else if( activeItem.hasClass('timeline-right') && (itemPositionIndex < halfScreen) ) {
			// 			activeItem.removeClass('timeline-right').addClass('timeline-left');
			// 		};
			// 	});

			// //correct timeline
			// 	var timelineItem = timelineList.find('.item');

			// 	timelineItem.each(function() {

			// 		var thisItem = $(this);

			// 		if (thisItem.hasClass('item-border')) {
			// 			timelineItemLinePosition =  parseInt(thisItem.offset().top + thisItem.outerHeight() + thisItem.css('marginTop') ) ;
			// 		}

			// 		else{

			// 			var blockWithLinePos = thisItem.find('.img, .iframe-out').offset().top;
			// 			var linePos = thisItem.find('.img, .iframe-out').outerHeight()/2  ;

			// 			timelineItemLinePosition =  parseInt(blockWithLinePos + linePos);

			// 		};

			// 		while(timelineItemLinePosition <= (timelineItemLinePositionPrev + 20 ) ){
			// 			var itemMargitTop = parseInt(thisItem.css('marginTop'));
			// 			var newMarginTop = itemMargitTop + 10;
			// 			timelineItemLinePosition = timelineItemLinePosition + 10;
			// 			thisItem.css('marginTop', newMarginTop);

			// 		};

			// 		timelineItemLinePositionPrev = timelineItemLinePosition

			// 	//correct timeline after right-left
			// 		var activeItem = $(this);
			// 		var itemPositionIndex = activeItem.offset().left + 10;
			// 		if ( activeItem.hasClass('timeline-left') && (itemPositionIndex > halfScreen) ) {
			// 			activeItem.removeClass('timeline-left').addClass('timeline-right');
			// 		}
			// 		else if( activeItem.hasClass('timeline-right') && (itemPositionIndex < halfScreen) ) {
			// 			activeItem.removeClass('timeline-right').addClass('timeline-left');
			// 		};


			// 	});


		};
	};


//front-page	
	if ($front.length) {
		var unitHide = $('#unit-hide');
		var unitMobOverlay = $('unit-mob-overlay');
		
		if ($('#wpadminbar').length) {
			$body.addClass('wpadminbar-active');
		};

		//dotdotdot
			$('.text').dotdotdot({});	
			$('.title').dotdotdot({});

			setTimeout(function(){
				$('.text').trigger("update.dot");
				$('.title').trigger("update.dot");
			},100);					

		//hide unit on full
			if ( !($breakpoint == 767) ) {
				//unit open
					$('.unit-hide').on('click touchstart', '.title-mini', function(event) {
							$('.unit').removeClass('unit-down');
					});
				//unit hide
					unitHide.on('click touchstart',function(event) {
						$(this).parent().toggleClass('unit-down');
						//return false
					});	
			};

		//hide unit on mob
			if ( ($breakpoint == 767) ) {
				//unit open
					var unit = $('.unit');

					unit.on('touchstart', '#unit-mob-overlay', function(event) {
						$('.unit-mob-open').removeClass('unit-mob-open');
						return false;
					});




					unit.on('touchstart', function(event) {
						if ( unit.hasClass('unit-mob-open')) {
								unitHide.on('click touchstart',function(event) {
									event.preventDefault();
									unit.removeClass('unit-mob-open');
									return false
								});
							//return false
						};
						$(this).addClass('unit-mob-open');
					});

					unitHide.on('touchstart' ,function(event) {
						//console.log('fff');
						if ( unit.hasClass('unit-mob-open')) {
								//unitHide.click(function(event) {
									event.preventDefault();
									//console.log('222');
									unit.removeClass('unit-mob-open');
									//return false
								//});
							return false
						};
						unit.addClass('unit-mob-open');
					});

			};			

	};





//contact-single page
	if ($contactSingle.length) {

	//detech
		if ($breakpoint == 767) {
			var blockForDetech = $('#user-contact').detach();
			var plaseForAdd = $('#user').find('.title-mini');
			blockForDetech.insertAfter(plaseForAdd);
		};

	};	






//projects-single
	if ($projectsSingle.length) {

		// if ((document.all && document.querySelector && !document.addEventListener)) {
		// 	$body.addClass('ie11');
		// };

		//btn for timeline
		var btnForTimeline = $('#btn-for-timeline');
		var btnForProjectSingle = $('#btn-projectSingle-back');
		var btnProjectSingleBackSmall = $('#btn-projectSingle-back-small');
		var btnSmall = $('.btn-small');



		//timeline
			var hash = window.location.hash;
			if ((hash == '#timeline')&&(btnForTimeline.length)) {
				$body.addClass('projects-timeline');

				setTimeout(timelineList, 10);
					btnForTimeline.addClass('clicked');
				}


		if ( $breakpoint == 8888) {
			$(window).scroll(function(){
				var windowScrollTop = $(window).scrollTop();
				if (windowScrollTop > 1) {
					btnForTimeline.addClass('btn-mod-scroll')
				}
				else{
					btnForTimeline.removeClass('btn-mod-scroll');
				};
			});
		};	

			btnForTimeline.click(function(event) {
				$body.addClass('projects-timeline');
				$('body,html').animate({scrollTop: 0}, 500);	


				if ($(this).hasClass('clicked')) {
					return false
				};	
				setTimeout(timelineList, 10);
				$(this).addClass('clicked');

				//event.preventDefault();
			});
			btnForProjectSingle.click(function(event) {
				$body.removeClass('projects-timeline');

				//event.preventDefault();
			});
			btnProjectSingleBackSmall.click(function(event) {
				$body.removeClass('projects-timeline');

				//event.preventDefault();
			});						

		//projects timeline btn-small
			$(window).scroll(function(){
				myScrollTop = $(window).scrollTop();
				if (myScrollTop > 200) {
					//btnProjectSingleBackSmall.addClass('btn-fixed');
					btnSmall.each(function() {
						$(this).addClass('btn-fixed')
					});
				}
				else{
					//btnProjectSingleBackSmall.removeClass('btn-fixed');
					btnSmall.each(function() {
						$(this).removeClass('btn-fixed')
					});
				}
			});	



	};



// document.addEventListener("wheel", function(e){
// 	console.log(e.wheelDeltaY);
// 	e.preventDefault();
// });





//work-with-us
	if ($workWithUs.length) {

			if ($breakpoint == 767) {
				$('.btn-arrow').on('click touchstart', function(event) {
					$header.each(function() {
						$(this).removeClass('header-sticky-show');
					});
				});
			};

		$('body,html').animate({scrollTop: 0}, 500);
		//nav-page
			var navPageItem = $navPage.find('.item');
			var navPageLink = navPageItem.find('.link');


			//nav absolute
				$(window).scroll(function(){

					var windowScrollTop = $(window).scrollTop();
					var windowH = $('#work-3').innerHeight();
					var scrollForAbsolute = windowH*2;
					var wpadminbarOffset = 0;
					if ($('#wpadminbar').length) {
						wpadminbarOffset = 32;
					};
					if (windowScrollTop>scrollForAbsolute + wpadminbarOffset) {
						$navPage.addClass('nav-page-absolute')
					}
					else{
						$navPage.removeClass('nav-page-absolute')
					};

					//nav acteve scroll
						var window_top = $(window).scrollTop();
							$(".blockForScroll").each(function () {
								var blockOffsetTop = $(this).offset().top;
								var blockId = $(this).attr('id');
								var menuForScroll = $navPage.find('.nav-page-in');
								var offsetTrue = 200;
								if ( (window_top >= blockOffsetTop - offsetTrue) ){
									menuForScroll.find('li').removeClass('current-menu-item');
									menuForScroll.find('.'+blockId+'').addClass('current-menu-item');
								}
								else{
									menuForScroll.find('.'+blockId+'').removeClass('current-menu-item');

								};
							});			


				});

			//nav active click	
				navPageLink.on('click touchstart',function(event) {
					navPageItem.removeClass('current-menu-item');
					$(this).parent().addClass('current-menu-item');
					// console.log('number '+$(this).parent().index());
					$body.data('sectionNumber',$(this).parent().index()+1)

				});

		//scroll one page
	

		if ( $breakpoint == 8888) {
			$body.addClass('block-1');

			// (function (w, d) {
			// 	var blocks = d.querySelectorAll('.work'),
			// 			ln = blocks.length,
			// 			index = 0,
			// 			stop = false,
			// 			direction,
			// 			next,
			// 			curr;

			// 	var mousewheelevt=(/Firefox/i.test(navigator.userAgent))? "DOMMouseScroll" : "mousewheel" //FF doesn't recognize mousewheel as of FF3.x

			// 	if (document.attachEvent) //if IE (and Opera depending on user setting)
			// 	    document.attachEvent("on"+mousewheelevt, function(e){})
			// 	else if (document.addEventListener) //WC3 browsers
			// 	    document.addEventListener(mousewheelevt,

			// 				function(event) {
			// 					event.preventDefault();
			// 					var evt = event.originalEvent ? event.originalEvent : event;
			// 					if (!stop) {
			// 						stop = true;
			// 						direction = evt.detail ? evt.detail*(-40) : evt.wheelDelta;
			// 						//console.log(event.wheel);

			// 						if (direction < 0) {
			// 					    index + 1 < ln ? index++ : "";
			// 							next = blocks[index];
			// 					    next ? next.classList.add('active') : "";

			// 							if ($body.hasClass('block-1')) {
			// 								$body.removeClass('block-1').addClass('block-2');
			// 								$('html, body').animate({scrollTop: $('#work-2').offset().top}, 1000);
			// 								// console.log('1');
			// 							}
			// 							else if ($body.hasClass('block-2')) {
			// 								$body.removeClass('block-2').addClass('block-3');
			// 								$('html, body').animate({scrollTop: $('#work-3').offset().top}, 1000);
			// 								// console.log('2');
			// 							}else if ($body.hasClass('block-3')) {
			// 								$body.removeClass('block-3').addClass('block-4');
			// 								$('html, body').animate({scrollTop: $('#footer').offset().top}, 1000);
			// 								// console.log('3');
			// 							};

			// 						} else {
			// 							curr = blocks[index];
			// 							if (curr) {
			// 								curr.classList.remove('active');
			// 								index > 0 ? index-- : "";
			// 								// console.log('4');
			// 							}
			// 							if ($body.hasClass('block-4')) {
			// 								$body.removeClass('block-4').addClass('block-3');
			// 								$('html, body').animate({scrollTop: $('#work-3').offset().top}, 1000);
			// 								// console.log('5');
			// 							}
			// 							else if ($body.hasClass('block-3')) {
			// 								$body.removeClass('block-3').addClass('block-2');
			// 								$('html, body').animate({scrollTop: $('#work-2').offset().top}, 1000);
			// 								// console.log('6');
			// 							}else if ($body.hasClass('block-2')) {
			// 								$body.removeClass('block-2').addClass('block-1');
			// 								$('html, body').animate({scrollTop: $('#main').offset().top}, 1000);
			// 								// console.log('7');
			// 							};
			// 						}
			// 						setTimeout(function () {
			// 							stop = false;
			// 						}, 1500);
			// 					}

			// 	    }, false);

			// }(window, document));





			var timerId;
			var stop = false;
			var scroll = true;
			var scrollConst = 30;

			if ( (document.all && window.atob) || (navigator.sayswho == 'IE 11.0') ) {
				var scrollConst = 150;
			}

			$body.data('sectionNumber',1);
			$('html, body').animate({scrollTop: $('#body').offset().top}, 10);
			// console.log($body.data('sectionNumber'));

			document.addEventListener("wheel", function(event){
				var scrollDelta = event.deltaY || event.wheelDeltaY;
				// console.log(scrollDelta);

				event.preventDefault();

					if (scrollDelta>scrollConst && scroll) {

						blockScroll();
						changeSectionNumber('down')
						
					};

					if (scrollDelta< -1*scrollConst && scroll) {

						blockScroll();
						changeSectionNumber('up')
						
					};



			});

			function blockScroll(){
				scroll = false;
				setTimeout(function() {
					scroll = true;
				}, 1000);
			};
			
			function changeSectionNumber(direction){
				var sectionNumber = $body.data('sectionNumber');
				if (direction == 'down' && sectionNumber<4) {
					scrollSectionTo(sectionNumber,direction);
					sectionNumber++;
					$body.data('sectionNumber',sectionNumber);
					// console.log($body.data('sectionNumber'));
				}else if(direction == 'up' && sectionNumber>1){
					scrollSectionTo(sectionNumber,direction);
					sectionNumber--;
					$body.data('sectionNumber',sectionNumber);
					// console.log($body.data('sectionNumber'));
				};
			};

			function scrollSectionTo(number,direction){
				// console.log(number);
				// console.log(direction);
				var section;
				if (direction == 'down') {
					switch(number){
						case 1:
							section = 'work-2'
							break;
						case 2:
							section = 'work-3'
							break;
						case 3:
							section = 'footer'
							break;																					
					}
				}else{
					switch(number){
						case 2:
							section = 'work-1'
							break;
						case 3:
							section = 'work-2'
							break;
						case 4:
							section = 'work-3'
							break;																					
					}
				};

				// console.log('scroll to section '+section);
				$('html, body').animate({scrollTop: $('#'+section).offset().top}, 1000);


			}








			var btnArrow1 = $('#work-1').find('.btn-arrow');
			var btnArrow2 = $('#work-2').find('.btn-arrow');
			var btnArrow3 = $('#work-3').find('.btn-arrow');

			btnArrow1.click(function(event) {
				$body.removeClass('block-1').addClass('block-2');
				$body.data('sectionNumber',2);
			});
			btnArrow2.click(function(event) {
				$body.removeClass('block-2').addClass('block-3');
				$body.data('sectionNumber',3);
			});
			btnArrow3.click(function(event) {
				$body.removeClass('block-3').removeClass('block-4').addClass('block-1');
				$body.data('sectionNumber',1);
			});

			// var btnNavPage1 = $navPage.find('.work-1').find('a');
			// var btnNavPage2 = $navPage.find('.work-2').find('a');
			// var btnNavPage3 = $navPage.find('.work-3').find('a');

			// btnNavPage1.click(function(event) {
			// 	$body.removeClass('block-2').removeClass('block-3').removeClass('block-4').addClass('block-1');
			// });
			// btnNavPage2.click(function(event) {
			// 	$body.removeClass('block-1').removeClass('block-3').removeClass('block-4').addClass('block-2');
			// });
			// btnNavPage3.click(function(event) {
			// 	$body.removeClass('block-2').removeClass('block-1').removeClass('block-4').addClass('block-3');
			// });

		};


			if ($('body').css('content')=='tab') {


			//tab-scroll
				var ystart = 0, ymove = 0;
				$body.addClass('block-1');
				$('section, footer').on('touchstart', function (e) {
					ystart = e.originalEvent.touches[0].clientY;
					ymove = e.originalEvent.touches[0].clientY;
				})
				.on('touchmove', function (e) {
					e.preventDefault();
					// console.log(e);
					// console.log(e.originalEvent);
					// console.log(e.originalEvent.touches[0]);
					//console.log(e.originalEvent.touches[0].target);
					ymove = e.originalEvent.touches[0].clientY;
				})
				.on('touchend', function (e) {
					if (ystart - ymove > 50) {
						if ($body.hasClass('block-1')) {
							$body.removeClass('block-1').addClass('block-2');
							$('html, body').animate({scrollTop: $('#work-2').offset().top}, 1000);
							return false;
						}
						else if ($body.hasClass('block-2')) {
							$body.removeClass('block-2').addClass('block-3');
							$('html, body').animate({scrollTop: $('#work-3').offset().top}, 1000);
							return false;
						}else if ($body.hasClass('block-3')) {
							$body.removeClass('block-3').addClass('block-4');
							$('html, body').animate({scrollTop: $('#footer').offset().top}, 1000);
							return false;
						};        
					}; 
					if (ymove - ystart > 50) {

						if ($body.hasClass('block-4')) {
							$body.removeClass('block-4').addClass('block-3');
							$('html, body').animate({scrollTop: $('#work-3').offset().top}, 1000);
							return false;
						}
						else if ($body.hasClass('block-3')) {
							$body.removeClass('block-3').addClass('block-2');
							$('html, body').animate({scrollTop: $('#work-2').offset().top}, 1000);
							return false;
						}else if ($body.hasClass('block-2')) {
							$body.removeClass('block-2').addClass('block-1');
							$('html, body').animate({scrollTop: $('#main').offset().top}, 1000);
							return false;
						}; 						
					};


					var btnArrow1 = $('#work-1').find('.btn-arrow');
					var btnArrow2 = $('#work-2').find('.btn-arrow');
					var btnArrow3 = $('#work-3').find('.btn-arrow');

					btnArrow1.on('touchstart', function(event) {
						$body.removeClass('block-1').addClass('block-2');
					});
					btnArrow2.on('touchstart', function(event) {			
						$body.removeClass('block-2').addClass('block-3');
					});
					btnArrow3.on('touchstart', function(event) {
						$body.removeClass('block-3').removeClass('block-4').addClass('block-1');
					});			

					var btnNavPage1 = $navPage.find('.work-1').find('a');
					var btnNavPage2 = $navPage.find('.work-2').find('a');
					var btnNavPage3 = $navPage.find('.work-3').find('a');

					btnNavPage1.on('touchstart', function(event) {
						$body.removeClass('block-2').removeClass('block-3').removeClass('block-4').addClass('block-1');
					});
					btnNavPage2.on('touchstart', function(event) {
						$body.removeClass('block-1').removeClass('block-3').removeClass('block-4').addClass('block-2');
					});
					btnNavPage3.on('touchstart', function(event) {	
						$body.removeClass('block-2').removeClass('block-1').removeClass('block-4').addClass('block-3');
					});	

				});
			};





		};

//input blur for Ipad

	$(window).on("orientationchange", function() {

		$searchInput.blur();
		$searchBig.blur();
		$body.removeClass('nav-open');
		$navPageIn.removeClass('nav-page-in-no-transition');

	});	

//iphone detect
	// if(navigator.userAgent.match(/iPhone/i) ) {
	// 	$body.addClass('iphone')
	// }


//setInterval(function(){console.log($flag);},10);
	//scroll fix
		$('#user').find('.btn-arrow').on('touchstart click', function(event) {
			$header.removeClass('header-sticky-show'); 
		});	





// Safari detect
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    $body.addClass('safari');
  };



//footer to bottom


	function footerToBottom(){

		setTimeout(function(){

			var newMinHeight = $(window).height() - $('.header').innerHeight() - $('footer').innerHeight() - $('.main-in').innerHeight() + 10;

			// console.log($(window).height());
			// console.log($('.header').innerHeight());
			// console.log($('footer').innerHeight());
			// console.log($('.main-in').innerHeight());
			// console.log(newMinHeight);

			$('.case').css('minHeight',newMinHeight);

		},200);

	};

	if ( $('.news-list').length>0 || $('.projects-content').length>0) {
		footerToBottom();
	}

	$( window ).on( "orientationchange resize", function() {
		if ( $('.news-list').length>0 || $('.projects-content').length>0) {
			footerToBottom();
		}

	});


	//fact-box page height fix

		if ($factBox.length ) {
			var landingIn = $('.landing-in');
			setTimeout(function(){

				var contentBoxHeaderH = $('.title-mega').outerHeight() + parseInt($('.title-mega').css('margin-bottom')) + $('.info-line').outerHeight() + parseInt($('.info-line').css('margin-bottom'));

				if ( (landingIn.outerHeight() - contentBoxHeaderH) <  $factBox.outerHeight() ) {
					landingIn.css('min-height', $factBox.outerHeight() + contentBoxHeaderH +'px');
				}
			
			}, 50);
		}

	//fact-box stycky
	
		if ($('.fact-box.sticky').length && $breakpoint == 8888) {
			setTimeout(function(){
				var stickyBox = $('.fact-box.sticky');
				var stickyBoxStartPosition = stickyBox.offset().top;
				var stickyOffsetTop = 150;
				var stickyOffsetBottom = 75;				
				var stickyBoxOffsetLeft = stickyBox.offset().left;
				var stickyBoxH = stickyBox.innerHeight()+ 2*parseInt(stickyBox.css('border-top-width'));
				var stickyBoxEndPosition = ($('#wpadminbar').outerHeight() || 0 ) + parseInt($main.css('padding-top')) + $('.landing').outerHeight() +($('.flexslider-full').outerHeight() || 0) - stickyBoxH - stickyOffsetTop - stickyOffsetBottom;

				$( window ).on( "orientationchange resize", function() {
					stickyBoxStartPosition = stickyBox.offset().top;			
					stickyBoxOffsetLeft = stickyBox.offset().left;
					stickyBoxH = stickyBox.innerHeight()+ 2*parseInt(stickyBox.css('border-top-width'));
					stickyBoxEndPosition = ($('#wpadminbar').outerHeight() || 0 ) + parseInt($main.css('padding-top')) + $('.landing').outerHeight() - stickyBoxH - stickyOffsetTop - stickyOffsetBottom;
					redrawFactBox();
				});

				redrawFactBox();

				function redrawFactBox(){
					if ($(document).scrollTop() > stickyBoxEndPosition) {
						$body.addClass('fact-box-sticky-bottom');
					}else if($(document).scrollTop() > stickyBoxStartPosition - stickyOffsetTop ){
						$body.addClass('fact-box-sticky-top').removeClass('fact-box-sticky-bottom');
						stickyBox.css({
							'top':stickyOffsetTop+'px',
							'left': stickyBoxOffsetLeft+'px'
						});
					}else{
						$body.removeClass('fact-box-sticky-top').removeClass('fact-box-sticky-bottom');
						stickyBox.css({
							'top':'',
							'left':''
						});					
					}
				};

				$(window).scroll(function(){
					redrawFactBox();
				});

			},100);

		}

var isMobileMenuOpened = false;
document.querySelector('.mobile-menu-button').addEventListener('click', function () {
	isMobileMenuOpened = !isMobileMenuOpened;
	document.body.classList.toggle('navigation-open');
	if(document.body.classList.contains('safari'))
	if (isMobileMenuOpened) {
		document.body.style.top = '-' + window.scrollY + 'px';
		document.body.style.position = 'fixed';
	} else {
		var scrollY = document.body.style.top;
		document.body.style.position = '';
		document.body.style.top = '';
		window.scrollTo(0, parseInt(scrollY || '0') * -1);
	}
});

function debounce(func, wait) {
	var timeout;
	return function() {
		var context = this,
				args = arguments;
		clearTimeout(timeout);
		timeout = setTimeout(function() {
			timeout = null;
			func.apply(context, args);
		}, wait);
		if (!timeout) func.apply(context, args);
	}
}

var header = document.getElementById('header');
var lastScrollTop = 0;

$(window).scroll(debounce(function (e) {
	var isMobileMenu = document.body.classList.contains('navigation-open');
	if (isMobileMenu) return;
	var top = window.pageYOffset || document.documentElement.scrollTop;
	if (top > 300 && top >= lastScrollTop) {
		header.classList.add('invisible');
	} else {
		header.classList.remove('invisible');
	}
	lastScrollTop = top <= 0 ? 0 : top;
	if (top === 0) header.classList.remove('detached');
	if (top > 300) {
		setTimeout(function () {
			header.classList.add('detached');
		}, 50);
	}
}, 10));


var timeout;
function removeInTransition(el) {
  clearTimeout(timeout);
  timeout = setTimeout(function() {
    el.removeClass('in-transition');
  }, 600);
}
$('.contact-item-front .readmore-link').click(function(e) {
  e.preventDefault();
  var li = $(e.currentTarget).closest('li');
  li.addClass('flipped').addClass('in-transition');
  removeInTransition(li);
});
$('.contact-item-back .close').click(function(e) {
  e.preventDefault();
  var li = $(e.currentTarget).closest('li');
  li.removeClass('flipped').addClass('in-transition');
  removeInTransition(li);
});

});
